export const getWorkspaceSetupSummary = (user) => {
    const hasDataset = Number(user?.noOfFileUploads || 0) > 0;
    const hasSubdomain = Boolean(user?.subdomain);
    const isOperational = hasDataset && hasSubdomain;

    const setupSteps = [
        {
            key: 'dataset',
            title: 'Dataset uploaded',
            description: hasDataset
                ? 'The workspace has at least one customer file available for processing and preview.'
                : 'A firm admin still needs to upload the first customer file.',
            completed: hasDataset,
        },
        {
            key: 'domain',
            title: 'Tenant domain reserved',
            description: hasSubdomain
                ? `The tenant URL ${user.subdomain}.finansee.eu is already reserved for this workspace.`
                : 'The custom tenant subdomain has not been reserved yet.',
            completed: hasSubdomain,
        },
        {
            key: 'live',
            title: 'Workspace ready to share',
            description: isOperational
                ? 'Data and domain setup are both present, so the workspace can be treated as go-live ready.'
                : 'Complete both data onboarding and domain setup before presenting this workspace as fully ready.',
            completed: isOperational,
        },
    ];

    const nextAction = !hasDataset
        ? {
            label: 'Open datasets',
            path: '/datasets',
            help: 'Upload the first customer file to provision analytics surfaces.',
        }
        : !hasSubdomain
            ? {
                label: 'Complete domain setup',
                path: '/domain',
                help: 'Reserve the tenant URL before sharing the workspace.',
            }
            : {
                label: 'Review dashboards',
                path: '/dashboard',
                help: 'The workspace is provisioned. Continue with review and validation.',
            };

    return {
        hasDataset,
        hasSubdomain,
        isOperational,
        domainUrl: hasSubdomain ? `${user.subdomain}.finansee.eu` : null,
        setupSteps,
        nextAction,
    };
};
